export default {"src":"/_next/static/media/YGGJ.b18b55d6.svg","height":200,"width":600,"blurWidth":0,"blurHeight":0};